// Generated by `bazel run i18n`. Do not edit by hand.
import en from "./en/customer-portal-shared.json";

export default en;
